module.exports = __webpack_public_path__ + "static/media/distribucion.d15ad3f0.svg";